import React from "react";

import Hero from "../../components/Hero";

const PublicarAnuncio: React.FC = () => {
  return (
    <>
      <Hero
        title="Aqui você cria seu anúncio, então vamos começar!"
        subtitle=""
        heroPath=""
      />
    </>
  );
};

export default PublicarAnuncio;
